var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_273_408827)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_273_408827",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_273_408827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.292 30.2917C34.9309 29.9306 34.7503 29.4861 34.7503 28.9583C34.7503 28.4306 34.9309 27.9861 35.292 27.625L38.042 24.9167H28.292C27.7642 24.9167 27.3131 24.7289 26.9387 24.3533C26.5631 23.9789 26.3753 23.5278 26.3753 23C26.3753 22.4722 26.5631 22.0206 26.9387 21.645C27.3131 21.2706 27.7642 21.0833 28.292 21.0833H38.042L35.292 18.375C34.9309 18.0139 34.7503 17.5622 34.7503 17.02C34.7503 16.4789 34.9309 16.0278 35.292 15.6667C35.6531 15.3056 36.0975 15.125 36.6253 15.125C37.1531 15.125 37.5975 15.3056 37.9587 15.6667L43.9587 21.6667C44.1253 21.8611 44.2503 22.0694 44.3337 22.2917C44.417 22.5139 44.4587 22.75 44.4587 23C44.4587 23.25 44.417 23.4861 44.3337 23.7083C44.2503 23.9306 44.1253 24.1389 43.9587 24.3333L37.9587 30.3333C37.5975 30.6944 37.1531 30.8611 36.6253 30.8333C36.0975 30.8056 35.6531 30.625 35.292 30.2917ZM18.042 40.3333L12.042 34.3333C11.8753 34.1389 11.7503 33.9306 11.667 33.7083C11.5837 33.4861 11.542 33.25 11.542 33C11.542 32.75 11.5837 32.5139 11.667 32.2917C11.7503 32.0694 11.8753 31.8611 12.042 31.6667L18.042 25.6667C18.4031 25.3056 18.8475 25.125 19.3753 25.125C19.9031 25.125 20.3475 25.3056 20.7087 25.6667C21.0698 26.0278 21.2503 26.4789 21.2503 27.02C21.2503 27.5622 21.0698 28.0139 20.7087 28.375L17.9587 31.0833H27.7087C28.2364 31.0833 28.6881 31.2711 29.0637 31.6467C29.4381 32.0211 29.6253 32.4722 29.6253 33C29.6253 33.5278 29.4381 33.9789 29.0637 34.3533C28.6881 34.7289 28.2364 34.9167 27.7087 34.9167H17.9587L20.7087 37.625C21.0698 37.9861 21.2503 38.4306 21.2503 38.9583C21.2503 39.4861 21.0698 39.9306 20.7087 40.2917C20.3475 40.6528 19.9031 40.84 19.3753 40.8533C18.8475 40.8678 18.4031 40.6944 18.042 40.3333Z",
    fill: "#ADADAD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_408827"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGray);
export default __webpack_public_path__ + "static/media/arrow-gray.c5c5162349237912a48d909e732c6912.svg";
export { ForwardRef as ReactComponent };